import { LocaleProvider } from '../providers/LocaleProvider';
import ThemeProvider from '../providers/ThemeProvider';
import React from 'react';
var Providers = function (props) {
    return (React.createElement(LocaleProvider, { locale: props.locale, locales: props.locales },
        React.createElement(ThemeProvider, null, props.children)));
};
export default Providers;
